const unitRouter = [
    {
        path: "list-unit",
        name: "unit",
        component: () => import("@/views/admin/unit"),
        default: true,
        meta: {
            model: "cs_unit",
            // requiresAuth: true,
        },
    },
    {
        path: "list-unit/add",
        name: "addUnit",
        component: () => import("@/views/admin/unit/function"),
        default: true,
        meta: {
            model: "cs_unit",
            // requiresAuth: true,
        },
    },
    {
        path: "list-unit/edit/:id",
        name: "editUnit",
        component: () => import("@/views/admin/unit/function"),
        default: true,
        meta: {
            model: "cs_unit",
            // requiresAuth: true,
        },
    },
];
export default unitRouter;